import { classNames } from 'shared/classNames';
import cls from './Text.module.scss';

export const Text = ({children, className, theme}) => {
    return (
        <p className={classNames(className, { [cls[theme]]: true }, [])}>
            {children}
        </p>
    );
}